import { useMemo } from 'react'
import useQueryParams from 'hooks/useQueryParams'
import { parseTransferOfferSearchDefaults } from 'lib/transfers/transferOfferSearchParams'

export default function useTransferOfferSearchDefaults() {
  const searchParams = useQueryParams()

  return useMemo(
    () => parseTransferOfferSearchDefaults(searchParams),
    [searchParams],
  )
}
